const NoPage = () => {
  return <h1></h1>;
};

export default NoPage;